import { InfoRoot } from './InfoRoot';

export const Info = {
  Root: InfoRoot,
};
